import * as React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import Button from '../../../../../../../Form/Button';
import UserGroupMembershipsStore from '../../Store';
import {
  FormTemplate,
  SelectionOption,
  fieldValue,
} from '../../../../../../../../Resource/FormTemplates/Types';
import { Maybe } from 'maybeasy';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  store: UserGroupMembershipsStore;
  template: FormTemplate;
}

const SubmitButton: React.FC<Props> = ({ store, template }) => {
  const userGroupSelected = (): Maybe<SelectionOption> =>
    fieldValue('user_group_id', 'single-selection', template);

  return userGroupSelected()
    .map((s) => (
      <Button
        type="button"
        value="Submit"
        onClick={() => {
          store.saving(s.value);
        }}
        data-intercom-target="add-participants-to-group-submit"
        className={clsx(
          'rounded-md border border-solid border-gray-900 bg-white',
          'py-2.5 px-5 text-sm font-semibold text-gray-900',
        )}
      />
    ))
    .getOrElse(emptyFragment);
};

export default observer(SubmitButton);
